/**
 * The web entry - what `index.js` is to the phone build.
 *
 * Deliberately NOT importing `index.js`: that file's whole job is native
 * plumbing (Firebase background handlers, notifee action routing, the WebRTC
 * runtime registration) and none of it exists in a browser. The web
 * equivalents of those seams are the `.web.ts` twins in `src/voice/`, which
 * the resolver picks automatically.
 *
 * The require bridge is first, and the position is load-bearing - see the
 * note in `require-bridge.ts` (and its longer twin at the top of
 * `src/voice/register-native.ts`, which is about this exact class of bug).
 */

import './require-bridge';
import './global.css';

import { AppRegistry } from 'react-native';
import App from '../App';
import appJson from '../app.json';

AppRegistry.registerComponent(appJson.name, () => App);
AppRegistry.runApplication(appJson.name, {
  rootTag: document.getElementById('root'),
});
